import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "./AuthProvider";

export default function ProtectedRoute({ children }) {
    const { isAuthorized, isReady } = useAuth();
    const location = useLocation();

    if (!isReady) {
        return <div className="flex-center h100">{"\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430..."}</div>;
    }

    if (!isAuthorized) {
        return <Navigate to={{ pathname: "/auth", search: location.search }} replace />;
    }

    return children;
}
